const pressReleases = {
    mixins: [mixins, mixin_intro_tabs],
    data () {
		return {
            handler: "",
            records: [],
            allItems:0,
            page: 1,
            year: "",
            month: "",
            iniTabData: null,
            roots: [],
            tags: [],
            tabOutTimer: 0
        }
    },
    created(){
        
    },
	mounted () {

        this.setIniTabData()

        setTimeout(()=>{
            this.loadData()
        })

        this.$watch(
            () => this.tab,
            (newVal, oldVal) => {
                this.setIniTabData()
                this.filterChanged()
            }
          )
	},
    methods:{
        setIniTabData(){
            if(this.iniTabData){
                this.month = this.iniTabData[this.tab].month
                this.year = this.iniTabData[this.tab].year
            }
        },
        beforeLoad(){
            api.fn.moveWindowToObj(jQuery(this.$el).find('.strip-conts'))
            this.loadData()
        },
        loadData(){
            this.loading = true;
            this.ajax(this.handler, 
                {
                    "year": this.year, 
                    "month": this.month, 
                    "page": this.page, 
                    "roots": this.iniTabData[this.tab].roots, 
                    "tags": this.iniTabData[this.tab].tags
                })
            
        },
        handleAjaxSuccess(data, obj) {
            this.allItems = parseInt(obj.allItems)
            this.records = []
            this.$nextTick(()=>{
                this.records = [].concat(...data)
            })
        },
        pageChanged(newPage){
            this.page = newPage
            this.beforeLoad()
        },
        filterChanged(){
            this.page = 1
            this.records = []
            this.loading = true;
            clearTimeout(this.tabOutTimer)

            this.tabOutTimer = setTimeout(()=>{
                this.beforeLoad()
            }, 500)
            
        }
    }
}

let pressReleasesApp = [];
const pressReleasesDiv = document.querySelectorAll(".s-press-releases");
if (pressReleasesDiv.length) {
    for (let i = 0; i < pressReleasesDiv.length; ++i) {
        if (pressReleasesDiv[i].id && pressReleasesDiv[i].id !== "") {
            pressReleasesApp.push(Vue.createApp({...pressReleases}));
            pressReleasesApp[i].directive('init', initDirective);
            pressReleasesApp[i].component('b-pagination', bPagination);
            pressReleasesApp[i].mount(`#${pressReleasesDiv[i].id}`);
        }
    }
}
